import React from "react";
import ReactExport from "react-export-excel";
import { Button } from "antd";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Excelldownload extends React.Component {
    render() {
        return (
            <ExcelFile
                element={<Button type="primary">Download Excel</Button>}
                filename="Purchase_Item_Report"
            >
                <ExcelSheet data={this.props.data} name="Purchase Items">
                    <ExcelColumn label="Date" value="purchase_date" />
                    <ExcelColumn label="PO Number" value="purchase_number" />
                    <ExcelColumn label="Item Code" value="Item" />
                    <ExcelColumn label="Item Title" value="item_title" />
                    <ExcelColumn label="Size" value="size" />
                    <ExcelColumn label="Category" value="category" />
                    <ExcelColumn label="Brand" value="brand" />
                    <ExcelColumn label="Supplier" value="supplier_name" />
                    <ExcelColumn label="Location" value="location_name" />
                    <ExcelColumn label="Quantity" value="quantity" />
                    <ExcelColumn label="Purchase Price" value="purchase_price" />
                    <ExcelColumn label="Selling Price" value="selling_price" />
                    <ExcelColumn
                        label="Total Purchase"
                        value={(col) => col.quantity * col.purchase_price}
                    />
                    <ExcelColumn
                        label="Total Selling"
                        value={(col) => col.quantity * col.selling_price}
                    />
                </ExcelSheet>
            </ExcelFile>
        );
    }
}

export default Excelldownload;
